import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getDropOffPointLocationLabel } from '@/DeliveryMethodsPage/helpers'

import * as Styles from './styles'

const SelectedDropOffPoint = ({ dropOffPoint, carrier }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      <Styles.NameContainer>
        {carrier.logo_url && <Styles.CarrierLogo src={carrier.logo_url} alt={carrier.name} />}
        <Styles.Name type="bodyMBold" color={theme.colors.primary.tone900}>
          {dropOffPoint.name}
        </Styles.Name>
      </Styles.NameContainer>
      <Text type="bodySRegular">{getDropOffPointLocationLabel(dropOffPoint)}</Text>
    </Styles.Container>
  )
}

export default SelectedDropOffPoint
